import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuthenticatedUser } from "~/hooks/useAuthenticatedUser";
import { UniversityStatsPage } from "~/components/statistics/university-stats-page";

export const Route = createFileRoute("/$tenantSlug/_protected/statistics")({
  component: StatisticsRoute,
});

function StatisticsRoute() {
  const { capabilities, routing } = useAuthenticatedUser();

  if (!capabilities?.canViewUniversityStats) {
    return <Navigate to={(routing?.homePath ?? "/dashboard")} replace />;
  }

  return <UniversityStatsPage />;
}
